document.addEventListener('DOMContentLoaded', () => {
  const mobileSlider = document.querySelector('.gallery__mobile-slider');
  if (!mobileSlider) return;

  const swiper = new Swiper(mobileSlider, {
    slidesPerView: 1.5,
    spaceBetween: 21,
    loop: false,
    grabCursor: true,
    on: {
      slideChange(swiper) {
        updateReview(swiper.activeIndex);
      },
    },
  });

  const reviews = document.querySelectorAll('.mobile-review-item');
  function updateReview(index) {
    reviews.forEach((el, i) => {
      el.style.display = i === index ? 'block' : 'none';
    });
  }

  // mostrar el primero al cargar
  updateReview(0);
});
